export var searchContextSymbol = Symbol('search-context');
/******************************* PRODUCTS ********************************/
export var CheckPointTraderSlug = 'checkpoint-trader';
export var DarkMoneyIndicatorSlug = 'dark-money-indicator';
export var DeepMarketTraderSlug = 'deep-market-trader';
export var MonthlyTrendTraderSlug = 'monthly-trend-trader';
export var OptionsSoupSlug = 'options-soup';
export var ProfitSkimmerSlug = 'profit-skimmer';
export var SectorFocusSlug = 'sector-focus';
export var SectorProphetsSlug = 'sector-prophets';
export var TechnicalAnalysisMillionaireSlug = 'technical-analysis-millionaire';
export var MegaTrendProfitClubSlug = 'mega-trend-profit-club';
export var SmallCapCashCowsSlug = 'small-cap-cash-cows';
export var TrueSovereignProfitsSlug = 'true-sovereign-profits';
/*********************** CONTENT MODEL "type" keys ***********************/
export var Alerts = 'alerts';
export var Articles = 'articles';
export var BonusReports = 'bonus-reports';
export var Sectors = 'sectors';
export var Tags = 'tags';
export var Webinars = 'webinars';
/**************************** GENERAL Constants **************************/
// The one empty-value token, EMPTY in @tmi/utils/formatting (visual-7); it used to be a fourth one, '---'. A literal
// rather than an import: build/sitemap.ts loads this file in Node, which cannot resolve @tmi/utils' extensionless imports.
export var MissingDataString = '—';
export var FiveMinutesInMilliseconds = 300000;
/**************************** SECTOR Constants **************************/
export var AllKey = 'all';
export var BullishPercentIndexKey = 'bpi';
export var PercentThirtyWeekKey = 'wk';
export var RelativeStrengthKey = 'rs';
/****************************** Permissions Keys *****************************/
export var TmiPublicContentPermissionKey = 'true-market-insiders';
export var TmiPublicContentNonHyphenated = 'true market insiders';
export var AllSectorBullishPercentIndexesPermissionKey = 'all-bpis';
export var ArticlesPermissionKey = 'articles';
export var BonusReportsPermissionKey = 'bonus-reports';
export var CoursePermissionsKey = 'courses';
export var DashboardPermissionsKey = 'dashboard';
export var DiscordPermissionsKey = 'discord-member';
export var EtfListingPermissionsKey = 'etf-listing';
export var MajorIndexBreadthPermissionsKey = 'major-index-breadth';
export var PortfolioBuilderPermissionKey = 'position-key';
export var PositionSizeCalculatorPermissionKey = 'position-size-calculator';
// SRS Calculator piggybacks on the equity-calculator feature flag — see
// types/permissions.ts:hasStockReplacementStrategyCalculatorAccess. The
// permission key here is informational; the actual gate is the feature
// flag check, not a server-side permission named 'srs-calculator'.
export var StockReplacementStrategyCalculatorPermissionKey = 'equity-calculator';
export var ProductTradeAlertsPermissionKey = 'trade-alerts';
export var ProfilePermissionKey = 'profile';
export var RelativeStrengthMatrixPermissionKey = 'rs-matrix';
export var SectorAlertsPermissionKey = 'alerts';
export var ShadowScannerPermissionKey = 'shadow-scanner';
// SSS is an exclusive tier: the Authorization service excludes it from the
// alliance/fullaccess umbrella expansion, so the grant only appears for users
// with a direct SSS assignment. Holding the code IS proof of entitlement —
// no client-side short-code exclusions are needed (they'd wrongly hide the
// scanner from fullaccess staff who also hold a direct SSS grant).
export var ShadowScannerShortCode = 'SSS';
export var SectorsPermissionKey = "".concat(Sectors);
export var SpreadCalculatorsPermissionKey = 'spread-calculators';
export var StockPermissionsKey = 'stocks';
export var WebinarsPermissionsKey = 'webinars';
/************************* ROUTE/ROUTER Constants ************************/
/*--------------------------- Public Page Path & Name Constants ---------------------------*/
export var AboutUsName = "about-us";
export var AboutUsPath = "/".concat(AboutUsName);
export var ContactUsSlug = "contact-us";
export var ContactUsDisplayText = 'Contact Us';
export var ContactUsPath = "/".concat(ContactUsSlug);
export var DashboardName = "dashboard";
export var ShadowSpikeName = "shadow-spike";
export var ShadowSpikePath = "/".concat(ShadowSpikeName);
export var DashboardPath = "/".concat(DashboardName);
export var EmailConfirmationSlug = "email-verification-confirmation";
export var EmailConfirmationPath = "/".concat(EmailConfirmationSlug);
export var TestimonialSlug = "testimonials";
export var TestimonialPath = "/".concat(TestimonialSlug);
export var ForbiddenName = "access-required";
export var ForbiddenPath = "/".concat(ForbiddenName);
export var HomeName = "home";
export var HomePath = "/";
export var MediaSlug = 'media';
export var MediaPath = "/".concat(MediaSlug);
export var NewPasswordName = "new-password";
export var NewPasswordPath = "/".concat(NewPasswordName, "/:challengeid/:answer");
export var PrivacyPolicySlug = 'privacy-policy';
export var PrivacyPolicyPath = "/".concat(PrivacyPolicySlug);
export var ProfileName = 'profile';
export var ProfilePath = "/".concat(ProfileName);
export var RefundPolicySlug = 'refund-policy';
export var RefundPolicyPath = "/".concat(RefundPolicySlug);
export var ResetPasswordName = "reset-password";
export var ResetPasswordPath = "/".concat(ResetPasswordName);
export var SignInName = "sign-in";
export var SignInPath = "/".concat(SignInName);
export var SignInAsUserName = "sign-in-as-a-user";
export var SignInAsUserPath = "".concat(SignInPath, "/:token");
export var SignUpName = "sign-up";
export var SignUpPath = "/".concat(SignUpName);
export var SmsTextPolicySlug = "sms-text-policy";
export var SmsTextPolicyPath = "/".concat(SmsTextPolicySlug);
export var TermsOfUsePolicySlug = "terms-of-use";
export var TermsOfUsePolicyPath = "/".concat(TermsOfUsePolicySlug);
export var WhitelistInstructionsSlug = "whitelist-instructions";
export var WhitelistInstructionsPath = "/".concat(WhitelistInstructionsSlug);
export var SectorEdgeSlug = 'sectoredge';
export var SectorEdgePath = "/".concat(SectorEdgeSlug);
var SectorDashEdgeSlug = 'sector-edge';
export var SectorDashEdgePath = "/".concat(SectorDashEdgeSlug);
/*--------------------------- Discord Path & Name Constants ----------------------------*/
export var DiscordName = 'discord';
export var DiscordPath = "/".concat(DiscordName);
export var DiscordCallbackName = 'discord-callback';
export var DiscordCallbackPath = "".concat(DiscordPath, "/oauth/callback");
/*------------------------- Learning/Course Path & Name Constants -------------------------*/
export var LearningName = "learning";
export var LearningPath = "/".concat(LearningName);
export var ArticleSearchName = "articles";
export var ArticleSearchPath = "".concat(LearningPath, "/").concat(ArticleSearchName);
export var ArticleName = "article";
export var ArticlePath = "".concat(LearningPath, "/").concat(ArticleSearchName, "/:slug");
export var RelatedArticlesPath = "".concat(LearningPath, "/").concat(Tags, "/:slug");
export var AuthorsName = "authors";
export var AuthorsPath = "".concat(LearningPath, "/").concat(AuthorsName);
export var AuthorBioName = "author";
export var AuthorBioPath = "".concat(AuthorsPath, "/:slug");
export var CoursesName = "courses";
export var CoursesPath = "".concat(LearningPath, "/").concat(CoursesName);
export var CourseName = "course";
export var CourseSlugKey = ":courseSlug";
export var CoursePath = "".concat(CoursesPath, "/").concat(CourseSlugKey);
export var WebinarsName = "webinars";
export var WebinarSearchPath = "".concat(LearningPath, "/").concat(WebinarsName);
export var All = "all";
export var Completed = "completed";
export var Main = "main";
export var Upcoming = "upcoming";
export var WebinarAllAliasPath = "".concat(WebinarSearchPath, "/").concat(All);
export var WebinarCompletedAliasPath = "".concat(WebinarSearchPath, "/").concat(Completed);
export var WebinarMainAliasPath = "".concat(WebinarSearchPath, "/").concat(Main);
export var WebinarUpcomingAliasPath = "".concat(WebinarSearchPath, "/").concat(Upcoming);
export var WebinarName = "webinar";
export var WebinarPath = "".concat(LearningPath, "/").concat(WebinarsName, "/:slug");
/*------------------------------ Tools Path & Name Constants ------------------------------*/
export var NyseBpiName = 'bpi';
export var NyseBpiPath = "/".concat(NyseBpiName);
/*----------------------------- Product Path & Name Constants -----------------------------*/
export var ProductsName = "products";
export var ProductsPath = "/".concat(ProductsName, "/:productSlug");
var ProductsAdvancedAliasName = 'products-advanced';
export var ProductsAdvancedAliasPath = "/".concat(ProductsAdvancedAliasName, "/:productSlug");
/*------------------------------ Alerts Path & Name Constants -----------------------------*/
export var AlertsName = "alerts";
export var TradeAlertsName = "trade-alerts";
export var TradeAlertsPath = "/".concat(TradeAlertsName);
export var TradeAlertName = "trade-alert";
export var TradeAlertPath = "".concat(TradeAlertsPath, "/:slug");
export var LearningTradeAlertsAliasPath = "".concat(LearningPath, "/").concat(AlertsName);
export var LearningTradeAlertAliasPath = "".concat(LearningPath, "/").concat(AlertsName, "/:slug");
export var SectorAlertsName = "sector-alerts";
export var SectorAlertsPath = "/".concat(SectorAlertsName);
export var AlertsAliasPath = "/".concat(Alerts);
/*------------------------------ Tools Path & Name Constants ------------------------------*/
export var ToolsName = "tools";
export var ToolsPath = "/".concat(ToolsName);
export var FavoritesSlug = "favorites";
export var AllSectorBPIsName = "all-bpis";
export var AllSectorBPIsPath = "".concat(ToolsPath, "/").concat(AllSectorBPIsName);
export var SectorBullishPercentIndicesName = "sector-bpis";
export var SectorBullishPercentIndicesPath = "".concat(ToolsPath, "/").concat(SectorBullishPercentIndicesName);
export var RelativeStrengthMatrixName = "rs-matrix";
export var RelativeStrengthMatrixPath = "".concat(ToolsPath, "/").concat(RelativeStrengthMatrixName);
export var MatrixHubRelativeStrengthPath = "".concat(ToolsPath, "/matrix-hub").concat(RelativeStrengthMatrixPath);
export var MajorIndexBreadthName = "major-index-breadth";
export var MajorIndexBreadthPath = "".concat(ToolsPath, "/").concat(MajorIndexBreadthName);
var OptionsName = "options";
export var EtfListingName = "etf-listing";
export var EtfListingPath = "".concat(ToolsPath, "/").concat(EtfListingName);
export var SectorTreeSlug = "sector-tree";
export var SectorTreePath = "".concat(ToolsPath, "/").concat(SectorTreeSlug);
export var SectorsName = "".concat(Sectors);
export var SectorsPath = "/".concat(Sectors);
export var SectorDetailsName = "".concat(Sectors, "-details");
export var SectorDetailsPath = "".concat(SectorsPath, "/:sector");
export var SectorDetailsPageName = "".concat(Sectors, "-details-page");
export var SectorDetailsPagePath = "".concat(SectorDetailsPath, "/details");
export var SectorDetailsPageDateQueryKey = "date";
export var SectorFavoritesName = "".concat(Sectors, "-").concat(FavoritesSlug);
export var SectorsFavoritesPath = "".concat(SectorsPath, "/").concat(FavoritesSlug);
export var EtfDetailsAliasPath = "/etfs/:ticker";
export var StockDetailsAliasPath = "/stocks/:ticker";
export var SecurityDetailsBasePath = "/securities";
export var SecurityDetailsPath = "".concat(SecurityDetailsBasePath, "/:ticker");
export var SecurityOptionsPath = "/securities/:ticker/".concat(OptionsName);
export var PortfoliosName = "portfolios";
export var PortfoliosPath = "".concat(ToolsPath, "/").concat(PortfoliosName);
export var PortfolioBuilderName = "portfolio-builder";
export var PortfolioBuilderPath = "".concat(ToolsPath, "/").concat(PortfolioBuilderName);
export var OptionsCalculatorName = "options-calculator";
export var OptionsCalculatorPath = "".concat(ToolsPath, "/").concat(OptionsCalculatorName);
export var PositionSizeCalculatorName = "position-size-calculator";
export var PositionSizeCalculatorPath = "".concat(ToolsPath, "/").concat(PositionSizeCalculatorName);
export var StockReplacementStrategyCalculatorName = "stock-replacement-strategy-calculator";
export var StockReplacementStrategyCalculatorPath = "".concat(ToolsPath, "/").concat(StockReplacementStrategyCalculatorName);
export var SpreadCalculatorKey = "spread-calculators";
/*------------------------- Profile Path & Name Constants -------------------------*/
export var MyLibraryName = "my-library";
export var MyLibraryPath = "".concat(ProfilePath, "/").concat(MyLibraryName);
export var BonusReportsName = "bonus-reports";
export var BonusReportsSearchName = "bonus-reports-search";
export var BonusReportsPath = "".concat(MyLibraryPath, "/").concat(BonusReportsName);
export var BonusReportsSearchPath = "".concat(LearningPath, "/").concat(BonusReportsName);
export var BonusReportsForProductPath = "".concat(BonusReportsPath, "?select-product=:productSlug");
export var MyArticlesPath = "".concat(MyLibraryPath);
export var MyWebinarsName = "favorite-webinars";
export var MyWebinarsPath = "".concat(MyLibraryPath, "/").concat(MyWebinarsName);
/*----------------------------------- Contentful category slug references -----------------------------------*/
export var NyseBpiUpdateCategorySlug = "nyse-bpi-updates";
export var TheWeekly3CategorySlug = "the-weekly-3";
/*------------------------------ Support Paths -----------------------------*/
var SupportName = "support";
var SupportPath = "/".concat(SupportName);
export var AppToolsName = "tools";
export var AppToolsPath = "".concat(SupportPath, "/").concat(AppToolsName);
export var ApplicationId = "bc8a907b-0e60-49a2-96ba-43a9b227c1d0";
